/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Save_Connection_SharedInputs */



/**
* | output |
* | --- |
* | "This model shares its connection with other models. Change the endpoint or key on the connection." |
*
* @param {Private_Models_Save_Connection_SharedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_save_connection_shared = /** @type {((inputs?: Private_Models_Save_Connection_SharedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Save_Connection_SharedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Modell teilt seine Verbindung mit anderen Modellen. Ändern Sie Endpunkt oder Schlüssel an der Verbindung.")
	return /** @type {LocalizedString} */ ("This model shares its connection with other models. Change the endpoint or key on the connection.")
});